import axios from "axios";
import Config from "../utils/Config";


class DashboardAPI {
    config = {
      headers: {
        Authorization: "",
        GroupId: "",
        CompanyId: "",
      },
    };
  
    setAccessToken(accessToken, groupId, companyId) {
      this.config.headers.Authorization = accessToken;
      this.config.headers.GroupId = groupId;
      this.config.headers.CompanyId = companyId;
    }
  
      //get Card details
      async getDocumentUploadDetails(accessToken, groupId, companyId) {
        this.setAccessToken(accessToken, groupId, companyId);
        const data = await axios.get(
          Config.BACKEND_URL + `/api/dashboard/dashboard-counts?companyId=${companyId}&groupId=${groupId}`,
          this.config
        );
        return data.data;
      }

      //get Table details
      async getIncompleteTradingPartnersData(accessToken, groupId, companyId) {
      this.setAccessToken(accessToken, groupId, companyId);
      console.log("Table API", accessToken,"-",groupId,"-",companyId)
      const data = await axios.get(
        Config.BACKEND_URL + `/api/dashboard/incompleteTradingPartners?companyId=${companyId}&groupId=${groupId}`,
        this.config
      );
      console.log("incomplete document table:",data)
      // const data ={
      //     data:{
      //         pendingDocuments: [
      //             {
      //                 invoiceNumber: "INV12345",
      //                 documentType: "Purchase Order",
      //                 uploadDate: "2023-10-01"
      //             },
      //             {
      //                 invoiceNumber: "INV67890",
      //                 documentType: "Sales Invoice",
      //                 uploadDate: "2023-10-05"
      //             },
      //             {
      //                 invoiceNumber: "INV54321",
      //                 documentType: "Credit Note",
      //                 uploadDate: "2023-10-10"
      //             }
      //         ]
      //     }
      // }

      return data.data;
      //return data;
    }

    //get Bar chart details
    async getDocSubmissionStatusData(accessToken, groupId, companyId) {
    this.setAccessToken(accessToken, groupId, companyId);
    const data = await axios.get(
      Config.BACKEND_URL + `/api/dashboard/documentStatusSummary?companyId=${companyId}&groupId=${groupId}`,
      this.config
    );
    return data.data;
    }

    //get PIE chart details
    async getDocumentTypeCounts(accessToken, groupId, companyId) {
      this.setAccessToken(accessToken, groupId, companyId);
      const data = await axios.get(
        Config.BACKEND_URL + `/api/dashboard/documentTypeCounts?companyId=${companyId}&groupId=${groupId}`,
        this.config
      );
      return data.data;
    }

  //get tax including /excluding data
  async getTaxIncludingExcludingData(accessToken, groupId, companyId) {
    this.setAccessToken(accessToken, groupId, companyId);
    const data = await axios.get(
      Config.BACKEND_URL + `/api/dashboard/invoiceTaxSummeryByDocumentType?companyId=${companyId}&groupId=${groupId}`,
      this.config
    );
    return data.data;
  }
  
  };
  export default new DashboardAPI();